import {
	TableTemplateButtons,
	TableTemplateButtonsEvent,
	TableTemplateTag,
} from "../components/table/table-template.model";
import { Task } from "../entities/task.model";
import { Formatter } from "../../services/formatter/formatter.service";
import { buildAlertPriorityTag } from "../../utils/alert-priority";

export class TaskRow implements Task {
	id: number;
	participantId?: number;
	ref?: string;
	name?: string;
	category?: string;
	resolved?: boolean;
	assignee?: number;
	priority?: string;
	description?: string;
	taskDate?: string;
	ruleId?: number;
	createdOn?: string;
	updatedOn?: string;
	type?: string;
	severity?: string;
	details?: string;
	reason?: string;
	state?: string;
	metadata?: string;
	resolutionType?: string;
	reachouts?: number;
	lastAttempt?: string;
	// Participant-specific
	kannactId?: string;
	firstName?: string;
	lastName?: string;
	status?: string;
	isTest?: boolean;
	participantName?: string;
	// Custom display fields
	entity: Task;
	resolvedLabel: string;
	priorityTag: TableTemplateTag;
	actionsTemplate: TableTemplateButtons;
	userState?: any;
	[key: string]: unknown;

	constructor(
		params: Task,
		editFn: (e: TableTemplateButtonsEvent) => void,
		resolveFn: (e: TableTemplateButtonsEvent) => void
	) {
		this.id = params.id;
		this.participantId = params.participantId;
		this.ref = params.ref;
		this.name = params.name;
		this.category = params.category;
		this.resolved = params.resolved;
		this.assignee = params.assignee;
		this.priority = params.priority;
		this.description = params.description;
		this.taskDate = params.taskDate;
		this.ruleId = params.ruleId;
		this.createdOn = params.createdOn;
		this.updatedOn = params.updatedOn;
		this.type = params.type;
		this.severity = params.severity;
		this.details = params.details;
		this.reason = params.reason;
		this.state = params.state;
		this.metadata = params.metadata;
		this.resolutionType = params.resolutionType;
		this.reachouts = params.reachouts;
		this.lastAttempt = params.lastAttempt;
		this.kannactId = params.userState?.kannactId;
		this.firstName = params.userState?.firstName;
		this.lastName = params.userState?.lastName;
		this.status = params.userState?.status;
		this.isTest = params.userState?.isTest;
		this.participantName = Formatter.fullName(
			params.userState?.firstName as string,
			params.userState?.lastName as string
		);
		this.userState = params.userState;
		this.entity = params;
		this.resolvedLabel = params.resolved ? "ENUMS.YES" : "ENUMS.NO";
		this.priorityTag = buildAlertPriorityTag(params.severity as string);
		this.actionsTemplate = params.resolved
			? [
					{
						id: "editAction",
						className: "p-button-text neutral",
						icon: "pi pi-pencil",
						disabled: false,
						onClick: editFn,
					},
				]
			: [
					{
						id: "editAction",
						className: "p-button-text neutral",
						icon: "pi pi-pencil",
						disabled: false,
						onClick: editFn,
					},
					{
						id: "resolveAction",
						className: "p-button-xs p-button-rounded",
						label: "PARTICIPANTS.TASKS.TABLE.ACTION_RESOLVE",
						disabled: false,
						onClick: resolveFn,
					},
				];
	}
}
